<template>
  <ToggleSection label="Fib Milling (Cryo TEM)" :collapsed="!dv.isEditing">
    <FieldGrid
      class="form-fields"
      :fields="[
        ['fibmilling_instrument', 'sputter_coating'],
        ['milling_angle', 'sputter_coating_time'],
        ['number_of_lamellae', 'gis_coating_time'],
        ['rough_milling_currents'],
        ['fine_milling_current', 'lamella_width'],
        ['final_lamella_thickness'],
      ]"
      :dv="dv"
      :validation-errors="validationErrors"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'FibMillingCryoTEM',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
    validationErrors: { type: Object, default: () => ({}) },
  },
}
</script>
